/* ==========================================================================
   VCG Hohenzollern – Theme-JavaScript
   Eigenständig geschrieben, ohne Abhängigkeiten. Jeder Baustein ist ein
   kleines Custom Element und funktioniert auch ohne die anderen.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var VCG = window.VCG = window.VCG || {};
  var routes = (window.VCG_DATA && window.VCG_DATA.routes) || {};
  var strings = (window.VCG_DATA && window.VCG_DATA.strings) || {};
  var settings = (window.VCG_DATA && window.VCG_DATA.settings) || {};

  /* ---------- Hilfsfunktionen ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function fetchSection(url, sectionId) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(parseHTML);
  }

  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.classList.add('is-locked'); }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  var toastTimer;
  function toast(message) {
    var el = $('#vcg-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3600);
  }

  function setStickyOffset() {
    var wrap = $('.site-header-wrapper');
    var offset = 0;
    if (wrap && wrap.classList.contains('is-sticky') && !wrap.classList.contains('is-hidden')) {
      offset = wrap.getBoundingClientRect().height;
    }
    var ann = $('.announcement');
    var annH = ann ? ann.getBoundingClientRect().height : 0;
    // erst messen, dann schreiben (verhindert erzwungenes Neu-Layout)
    document.documentElement.style.setProperty('--sticky-offset', offset + 'px');
    document.documentElement.style.setProperty('--announcement-h', annH + 'px');
  }

  VCG.$ = $; VCG.$$ = $$; VCG.toast = toast; VCG.fetchSection = fetchSection;

  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  /* ---------- Drawer ---------- */
  class VcgDrawer extends HTMLElement {
    connectedCallback() {
      // Schubladen mit data-portal an <body> hängen, damit kein Eltern-Element
      // (z. B. die mitlaufende Produktinfo) sie unter den Header schiebt.
      if (this.hasAttribute('data-portal') && this.parentElement !== document.body) {
        $$('body > vcg-drawer').forEach((d) => { if (d.id === this.id && d !== this) d.remove(); });
        this._moving = true;
        document.body.appendChild(this);
        this._moving = false;
        return;
      }
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('.drawer__panel');
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
          e.preventDefault();
          this.close();
        }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
        var items = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([tabindex="-1"]), textarea, [tabindex]:not([tabindex="-1"])', this.panel)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    disconnectedCallback() {
      if (this.classList.contains('is-open') && !this._moving) { this.classList.remove('is-open'); unlockScroll(); }
    }
    open(trigger) {
      if (this.classList.contains('is-open')) return;
      this.trigger = trigger || document.activeElement;
      $$('vcg-drawer.is-open').forEach((d) => { if (d !== this) d.close(); });
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      lockScroll();
      var focusTarget = this.querySelector('[data-autofocus]') || this.querySelector('input, button, a');
      setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 60);
      this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    }
  }
  define('vcg-drawer', VcgDrawer);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (!opener) return;
    var drawer = document.getElementById(opener.getAttribute('data-drawer-open'));
    if (!drawer || !drawer.open) return;
    if (opener.getAttribute('data-drawer-open') === 'CartDrawer' && settings.cartType === 'page') return;
    e.preventDefault();
    drawer.open(opener);
  });

  /* ---------- Auswahlfeld (ersetzt die Browser-Liste, das echte <select> bleibt für Formulare) ---------- */
  var selectCount = 0;
  class VcgSelect extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this._ready = true;
      var id = 'vselect-' + (++selectCount);
      this.select.classList.add('vselect__native');
      this.select.setAttribute('tabindex', '-1');
      this.select.setAttribute('aria-hidden', 'true');
      var label = this.select.id ? document.querySelector('label[for="' + this.select.id + '"]') : null;
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'vselect__button';
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-controls', id);
      if (label) { if (!label.id) label.id = id + '-label'; this.button.setAttribute('aria-labelledby', label.id + ' ' + id + '-value'); }
      this.button.innerHTML = '<span class="vselect__value" id="' + id + '-value"></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10l5 5 5-5"/></svg>';
      this.list = document.createElement('ul');
      this.list.className = 'vselect__list';
      this.list.id = id;
      this.list.setAttribute('role', 'listbox');
      this.list.hidden = true;
      Array.prototype.forEach.call(this.select.options, (opt, i) => {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('tabindex', '-1');
        li.dataset.index = i;
        li.textContent = opt.textContent.trim();
        if (opt.lang) li.lang = opt.lang;
        this.list.appendChild(li);
      });
      this.select.after(this.button, this.list);
      this.sync();
      this.button.addEventListener('click', () => this.toggle());
      this.button.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); this.open(); }
      });
      this.list.addEventListener('click', (e) => {
        var li = e.target.closest('li'); if (li) this.choose(parseInt(li.dataset.index, 10));
      });
      this.list.addEventListener('keydown', (e) => {
        var items = $$('li', this.list);
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[i]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[i]).focus(); }
        else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) this.choose(i); }
        else if (e.key === 'Escape') { e.preventDefault(); this.close(true); }
        else if (e.key === 'Tab') { this.close(false); }
      });
      this._outside = (e) => { if (!this.contains(e.target)) this.close(false); };
    }
    sync() {
      var opt = this.select.options[this.select.selectedIndex];
      this.button.querySelector('.vselect__value').textContent = opt ? (opt.getAttribute('data-short') || opt.textContent.trim()) : '';
      $$('li', this.list).forEach((li, i) => li.setAttribute('aria-selected', i === this.select.selectedIndex ? 'true' : 'false'));
    }
    toggle() { if (this.list.hidden) this.open(); else this.close(true); }
    open() {
      $$('vcg-select.is-open').forEach((o) => { if (o !== this) o.close(false); });
      this.list.hidden = false;
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      // nach oben öffnen, wenn unten kein Platz ist
      var r = this.button.getBoundingClientRect();
      this.classList.toggle('is-up', window.innerHeight - r.bottom < Math.min(this.list.scrollHeight, 320) + 16 && r.top > window.innerHeight - r.bottom);
      var sel = this.list.querySelector('[aria-selected="true"]') || this.list.firstElementChild;
      if (sel) { sel.focus({ preventScroll: true }); sel.scrollIntoView({ block: 'nearest' }); }
      document.addEventListener('click', this._outside, true);
    }
    close(refocus) {
      if (this.list.hidden) return;
      this.list.hidden = true;
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._outside, true);
      if (refocus) this.button.focus({ preventScroll: true });
    }
    choose(i) {
      var changed = this.select.selectedIndex !== i;
      this.select.selectedIndex = i;
      this.sync();
      this.close(true);
      if (changed) this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  define('vcg-select', VcgSelect);

  /* ---------- Header ---------- */
  class VcgHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.wrapper = this.closest('.site-header-wrapper');
      this.header = this.querySelector('.site-header');
      this.sticky = this.wrapper && this.wrapper.classList.contains('is-sticky');
      this.transparent = this.wrapper && this.wrapper.classList.contains('is-transparent');
      this.hideOnScroll = this.hasAttribute('data-hide-on-scroll');
      this.lastY = window.scrollY;

      var measure = () => {
        document.documentElement.style.setProperty('--header-h', this.header.getBoundingClientRect().height + 'px');
      };
      measure();
      window.addEventListener('resize', debounce(measure, 100));
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(this.header);
      var onScroll = () => {
        var y = window.scrollY;
        var annH = 0;
        var ann = document.querySelector('.announcement');
        if (ann) annH = ann.getBoundingClientRect().height;
        if (this.transparent) this.header.classList.toggle('is-solid', y > Math.max(10, annH) || !!this.hovering);
        if (this.sticky && this.hideOnScroll) {
          var hidden = this.wrapper.classList.contains('is-hidden');
          if (y <= 300 || this.hovering) { hidden = false; this.lastY = y; }
          else if (y > this.lastY + 6) { hidden = true; this.lastY = y; }
          else if (y < this.lastY - 6) { hidden = false; this.lastY = y; }
          this.wrapper.classList.toggle('is-hidden', hidden);
        } else {
          this.lastY = y;
        }
        setStickyOffset();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', debounce(setStickyOffset, 150));
      onScroll();

      if (this.transparent) {
        this.header.addEventListener('mouseenter', () => { this.hovering = true; this.header.classList.add('is-solid'); });
        this.header.addEventListener('mouseleave', () => { this.hovering = false; onScroll(); });
        this.header.addEventListener('focusin', () => { this.hovering = true; this.header.classList.add('is-solid'); });
        this.header.addEventListener('focusout', () => { this.hovering = false; onScroll(); });
      }

      // Menüpunkte mit Untermenü per Tastatur/Touch öffnen
      $$('.site-nav__item[data-has-menu]', this).forEach(function (item) {
        var link = item.querySelector('.site-nav__link');
        link.addEventListener('touchend', function (e) {
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            $$('.site-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
            item.classList.add('is-open');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.site-nav__item')) $$('.site-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      });
    }
  }
  define('vcg-header', VcgHeader);

  /* ---------- Ankündigungsleiste ---------- */
  class VcgAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announcement__item', this);
      if (this.items.length < 2) return;
      var speed = parseInt(this.getAttribute('data-speed') || '5', 10) * 1000;
      var i = 0;
      var mq = window.matchMedia('(min-width: 990px)');
      var inline = this.classList.contains('announcement--inline');
      setInterval(() => {
        if (inline && mq.matches) return;
        this.items[i].classList.remove('is-active');
        i = (i + 1) % this.items.length;
        this.items[i].classList.add('is-active');
      }, speed);
    }
  }
  define('vcg-announcement', VcgAnnouncement);

  /* ---------- Hero-Slideshow ---------- */
  class VcgSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.hero__slide', this);
      requestAnimationFrame(() => this.classList.add('is-ready'));
      this.dots = $$('.hero__dot', this);
      this.index = 0;
      this.speed = parseFloat(this.getAttribute('data-speed') || '0') * 1000;
      if (this.slides.length < 2) return;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.restart());
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); else this.restart(); });
      var startX = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        startX = null;
      });
      this.restart();
    }
    go(i) {
      var n = this.slides.length;
      i = (i + n) % n;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      if (this.dots[this.index]) { this.dots[this.index].classList.remove('is-active'); this.dots[this.index].removeAttribute('aria-current'); }
      this.index = i;
      var cur = this.querySelector('[data-hero-current]');
      if (cur) cur.textContent = i + 1;
      this.slides[i].classList.add('is-active');
      this.slides[i].removeAttribute('aria-hidden');
      if (this.dots[i]) {
        var dot = this.dots[i];
        dot.classList.remove('is-active');
        void dot.offsetWidth;
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      }
      $$('img[loading="lazy"]', this.slides[i]).forEach(function (img) { img.loading = 'eager'; });
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() {
      this.stop();
      if (!this.speed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.dots.forEach(function (d) { d.classList.add('is-static'); });
        return;
      }
      this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }
  }
  define('vcg-slideshow', VcgSlideshow);

  /* ---------- Marken-Welt ---------- */
  class VcgBrandList extends HTMLElement {
    connectedCallback() {
      this.frames = $$('.brands__frame', this);
      if (this.frames[0]) this.frames[0].classList.add('is-active');
      $$('[data-brand-index]', this).forEach((link) => {
        var show = () => {
          var i = link.getAttribute('data-brand-index');
          var target = this.querySelector('.brands__frame[data-frame="' + i + '"]');
          if (target) this.frames.forEach(function (f) { f.classList.toggle('is-active', f === target); });
          $$('.brands__link', this).forEach(function (l) { l.classList.toggle('is-active', l === link); });
        };
        link.addEventListener('mouseenter', show);
        link.addEventListener('focus', show);
      });
    }
  }
  define('vcg-brand-list', VcgBrandList);

  /* ---------- Tabs ---------- */
  class VcgTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.panels = $$('[role="tabpanel"]', this);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { this.select((i + 1) % this.tabs.length, true); }
          if (e.key === 'ArrowLeft') { this.select((i - 1 + this.tabs.length) % this.tabs.length, true); }
        });
      });
    }
    select(i, focus) {
      this.tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      this.panels.forEach(function (p, j) { p.hidden = j !== i; });
      if (focus) this.tabs[i].focus();
      $$('.reveal', this.panels[i]).forEach(function (el) { el.classList.add('is-visible'); });
      initRails(this.panels[i]);
    }
  }
  define('vcg-tabs', VcgTabs);

  /* ---------- Einblenden beim Scrollen ---------- */
  function initReveal(root) {
    var items = $$('.reveal-image:not(.is-visible)', root);
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || !settings.reveal) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    // Beobachtet wird das Elternelement: das Bild selbst ist bis zum Einblenden
    // per clip-path auf null Fläche beschnitten und würde nie „sichtbar“.
    var map = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        (map.get(entry.target) || []).forEach(function (el) { el.classList.add('is-visible'); });
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    items.forEach(function (el) {
      var host = el.closest('[data-reveal-host]') || el.parentElement || el;
      if (!map.has(host)) { map.set(host, []); io.observe(host); }
      map.get(host).push(el);
    });
  }
  VCG.initReveal = initReveal;
  // Große Aufmacher-Bilder (z. B. Rampenlicht) nach dem Laden der Seite schon im Hintergrund holen,
  // damit sie beim Hinscrollen sofort da sind.
  window.addEventListener('load', function () {
    var go = function () { $$('.reveal-hero img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; }); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
  });

  /* ---------- Galerie ---------- */
  class VcgGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = $('.gallery__viewport', this);
      this.slides = $$('.gallery__slide', this);
      this.dots = $$('.gallery__dot', this);
      this.thumbs = $$('.gallery__thumbs button', this);
      this.counter = $('.gallery__counter', this);
      this.prev = $('.gallery__arrow--prev', this);
      this.next = $('.gallery__arrow--next', this);
      this.index = 0;
      if (!this.viewport) return;

      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.viewport.addEventListener('scroll', debounce(() => this.sync(), 60), { passive: true });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.go(this.index + 1);
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
      });
      $$('.gallery__zoom', this).forEach((btn, i) => btn.addEventListener('click', () => VCG.lightbox && VCG.lightbox.open(this, i)));
      this.update();
    }
    isLinear() {
      var style = getComputedStyle(this.viewport);
      return style.display === 'flex';
    }
    go(i) {
      var n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      if (!this.isLinear()) { this.slides[i].scrollIntoView({ behavior: 'smooth', block: 'center' }); this.index = i; this.update(); return; }
      this.viewport.scrollTo({ left: this.slides[i].offsetLeft - this.viewport.offsetLeft, behavior: 'smooth' });
      this.index = i;
      this.update();
    }
    sync() {
      if (!this.isLinear()) return;
      var w = this.viewport.clientWidth || 1;
      var i = Math.round(this.viewport.scrollLeft / w);
      if (i !== this.index) { this.index = i; this.update(); }
    }
    update() {
      var i = this.index, n = this.slides.length;
      this.dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      this.thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + n;
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i >= n - 1;
    }
    goToMedia(mediaId) {
      var idx = this.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) this.go(idx);
    }
  }
  define('vcg-gallery', VcgGallery);

  /* ---------- Lightbox ---------- */
  VCG.lightbox = {
    el: null,
    build: function () {
      if (this.el) return this.el;
      var el = document.createElement('div');
      el.className = 'lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', strings.zoom || 'Zoom');
      el.innerHTML =
        '<button type="button" class="lightbox__close" aria-label="' + (strings.close || 'Close') + '">' + icon('close') + '</button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--prev" aria-label="' + (strings.previous || 'Previous') + '">' + icon('left') + '</button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--next" aria-label="' + (strings.next || 'Next') + '">' + icon('right') + '</button>' +
        '<div class="lightbox__viewport"></div><div class="lightbox__count"></div>';
      document.body.appendChild(el);
      var self = this;
      el.querySelector('.lightbox__close').addEventListener('click', function () { self.close(); });
      el.querySelector('.lightbox__nav--prev').addEventListener('click', function () { self.go(self.index - 1); });
      el.querySelector('.lightbox__nav--next').addEventListener('click', function () { self.go(self.index + 1); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          var f = $$('button', el); var i = f.indexOf(document.activeElement);
          e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
        }
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowRight') self.go(self.index + 1);
        if (e.key === 'ArrowLeft') self.go(self.index - 1);
      });
      el.querySelector('.lightbox__viewport').addEventListener('scroll', debounce(function () {
        var vp = el.querySelector('.lightbox__viewport');
        self.index = Math.round(vp.scrollLeft / (vp.clientWidth || 1));
        self.count();
      }, 80), { passive: true });
      this.el = el;
      return el;
    },
    open: function (gallery, index) {
      this.trigger = document.activeElement;
      var el = this.build();
      var vp = el.querySelector('.lightbox__viewport');
      var sources = $$('.gallery__zoom', gallery).map(function (b) { return { src: b.getAttribute('data-zoom-src'), alt: b.getAttribute('data-alt') || '' }; });
      vp.innerHTML = sources.map(function (s) {
        return '<div class="lightbox__slide"><img src="' + s.src + '" alt="' + s.alt.replace(/"/g, '&quot;') + '" loading="lazy"></div>';
      }).join('');
      $$('.lightbox__slide img', vp).forEach(function (img) {
        img.addEventListener('click', function (e) {
          var slide = img.parentElement;
          var zoomed = slide.classList.toggle('is-zoomed');
          if (zoomed) {
            var rect = img.getBoundingClientRect();
            var rx = (e.clientX - rect.left) / rect.width, ry = (e.clientY - rect.top) / rect.height;
            requestAnimationFrame(function () {
              slide.scrollLeft = rx * slide.scrollWidth - slide.clientWidth / 2;
              slide.scrollTop = ry * slide.scrollHeight - slide.clientHeight / 2;
            });
          }
        });
      });
      this.total = sources.length;
      el.classList.add('is-open');
      lockScroll();
      this.index = index || 0;
      requestAnimationFrame(() => { vp.scrollLeft = vp.clientWidth * this.index; this.count(); });
      el.querySelector('.lightbox__close').focus();
    },
    go: function (i) {
      var vp = this.el.querySelector('.lightbox__viewport');
      i = Math.max(0, Math.min(this.total - 1, i));
      this.index = i;
      vp.scrollTo({ left: vp.clientWidth * i, behavior: 'smooth' });
      this.count();
    },
    count: function () { this.el.querySelector('.lightbox__count').textContent = (this.index + 1) + ' / ' + this.total; },
    close: function () { this.el.classList.remove('is-open'); unlockScroll(); if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true }); }
  };

  function icon(name) {
    var p = {
      close: '<path d="M4 4l16 16M20 4L4 20"/>',
      left: '<path d="M15 4l-8 8 8 8"/>',
      right: '<path d="M9 4l8 8-8 8"/>'
    }[name];
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">' + p + '</svg>';
  }

  /* ---------- Warenkorb ---------- */
  var Cart = VCG.cart = {
    sections: function () {
      return $$('[data-cart-section]').map(function (el) { return el.getAttribute('data-cart-section'); })
        .filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = parseHTML(html);
        $$('[data-cart-section="' + id + '"]').forEach(function (target) {
          var key = target.getAttribute('data-cart-part');
          var source = key ? doc.querySelector('[data-cart-part="' + key + '"]') : doc.querySelector('[data-cart-section="' + id + '"]');
          if (source) { target.innerHTML = source.innerHTML; target.hidden = source.hidden; }
        });
      });
      Cart.refreshCount();
    },
    refreshCount: function () {
      fetch(routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }).catch(function () {});
    },
    resync: function () {
      var ids = Cart.sections();
      if (!ids.length) return;
      fetch(routes.root + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(Cart.render).catch(function () {});
    },
    // Einzelnen Artikel hinzufügen und Warenkorb öffnen (z. B. aus der Wunschliste)
    add: function (variantId, button) {
      if (button) button.classList.add('is-loading');
      return fetch(routes.cart_add + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: Cart.sections(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status) { toast(data.description || data.message || strings.error); return false; }
        Cart.render(data.sections);
        $$('vcg-drawer.is-open').forEach(function (d) { if (d.id !== 'CartDrawer') d.close(); });
        var drawer = document.getElementById('CartDrawer');
        if (drawer && drawer.open && settings.cartType !== 'page') drawer.open(button); else window.location.href = routes.cart;
        return true;
      }).catch(function () { toast(strings.error || 'Error'); return false; })
        .finally(function () { if (button) button.classList.remove('is-loading'); });
    },
    change: function (line, quantity, container) {
      if (container) container.classList.add('is-loading');
      return fetch(routes.cart_change + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: Cart.sections(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status && data.description) { toast(data.description); Cart.resync(); return; }
        Cart.render(data.sections);
      }).catch(function () { toast(strings.error || 'Error'); Cart.resync(); })
        .finally(function () { if (container) container.classList.remove('is-loading'); });
    }
  };

  // „In den Warenkorb“ außerhalb der Produktseite (z. B. Rampenlicht auf der Startseite)
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (!add) return;
    e.preventDefault();
    Cart.add(parseInt(add.getAttribute('data-add-to-cart'), 10), add);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      Cart.change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, remove.closest('[data-cart-section]'));
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.quantity');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line]');
    if (input) Cart.change(parseInt(input.getAttribute('data-cart-line'), 10), parseInt(input.value, 10) || 0, input.closest('[data-cart-section]'));
  });

  document.addEventListener('change', debounce(function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(routes.cart_update + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  }, 300));

  /* ---------- Produktformular ---------- */
  class VcgProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[type="submit"]');
      this.error = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', (e) => this.submit(e));
    }
    submit(e) {
      // Bereits im Warenkorb (Einzelstück): Warenkorb öffnen statt erneut hinzufügen
      if (this.classList.contains('is-in-cart')) {
        e.preventDefault();
        var cd = document.getElementById('CartDrawer');
        if (cd && cd.open && settings.cartType !== 'page') cd.open(this.button); else window.location.href = routes.cart;
        return;
      }
      if (settings.cartType === 'page' && !this.hasAttribute('data-force-drawer')) return;
      e.preventDefault();
      if (!this.button || this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) return;
      this.button.classList.add('is-loading');
      if (this.error) this.error.hidden = true;
      var fd = new FormData(this.form);
      var sections = Cart.sections();
      if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }
      fetch(routes.cart_add + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then((data) => {
          if (data.status) {
            var msg = data.description || data.message || strings.error;
            if (this.error) { this.error.textContent = msg; this.error.hidden = false; } else { toast(msg); }
            return;
          }
          Cart.render(data.sections);
          var drawer = document.getElementById('CartDrawer');
          if (drawer && drawer.open) drawer.open(this.button);
          else window.location.href = routes.cart;
        })
        .catch(function () { toast(strings.error || 'Error'); })
        .finally(() => { this.button.classList.remove('is-loading'); });
    }
  }
  define('vcg-product-form', VcgProductForm);

  // Artikel schon im Warenkorb und keine weitere Menge verfügbar (z. B. Einzelstück):
  // Kaufknopf und Kaufleiste zeigen „Bereits im Warenkorb“ und öffnen den Warenkorb.
  function syncInCart(cart) {
    var items = (cart && cart.items) || [];
    $$('vcg-product-form').forEach(function (pf) {
      var input = pf.querySelector('input[name="id"]'); var btn = pf.querySelector('[name="add"]');
      if (!input || !btn) return;
      if (!pf._label) pf._label = btn.textContent.trim();
      if (btn.disabled && !pf.classList.contains('is-in-cart')) return;
      var id = parseInt(input.value, 10);
      var qty = items.reduce(function (sum, it) { return it.variant_id === id ? sum + it.quantity : sum; }, 0);
      var max = pf.getAttribute('data-max');
      var full = qty > 0 && max !== null && max !== '' && qty >= parseInt(max, 10);
      pf.classList.toggle('is-in-cart', full);
      btn.textContent = full ? pf.getAttribute('data-label-in-cart') : pf._label;
      var err = pf.querySelector('[data-form-error]'); if (full && err) err.hidden = true;
      $$('vcg-sticky-buy', document).forEach(function (bar) {
        var sb = bar.querySelector('[data-sticky-submit]'); if (!sb) return;
        if (!bar._label) bar._label = sb.textContent.trim();
        bar.classList.toggle('is-in-cart', full);
        sb.textContent = full ? pf.getAttribute('data-label-in-cart') : bar._label;
      });
    });
  }
  document.addEventListener('cart:updated', function (e) { syncInCart(e.detail); });
  if (document.querySelector('vcg-product-form[data-max]:not([data-max=""])')) {
    fetch(routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(syncInCart).catch(function () {});
  }

  /* ---------- Variantenauswahl ---------- */
  class VcgVariantPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', () => this.onChange());
    }
    onChange() {
      var dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var selected = $$('fieldset', this).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      $$('select', this).forEach(function (s, i) { selected[i] = s.value; });
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      var sectionId = this.getAttribute('data-section');
      var root = this.closest('[data-product-root]') || document;
      var idInput = root.querySelector('vcg-product-form form input[name="id"]');
      $$('fieldset', this).forEach(function (fs) {
        var checked = fs.querySelector('input:checked'); var span = fs.querySelector('legend span');
        if (checked && span) span.textContent = checked.value;
      });
      var addBtn = root.querySelector('vcg-product-form [name="add"]');
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = strings.unavailable || ''; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (this.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      fetchSection(this.getAttribute('data-url') + '?variant=' + variant.id, sectionId).then(function (doc) {
        $$('[data-pdp-dynamic]', root).forEach(function (el) {
          var key = el.getAttribute('data-pdp-dynamic');
          var fresh = doc.querySelector('[data-pdp-dynamic="' + key + '"]');
          if (fresh) { el.innerHTML = fresh.innerHTML; el.style.opacity = ''; }
        });
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) window.Shopify.PaymentButton.init();
        var gallery = root.querySelector('vcg-gallery');
        if (gallery && variant.featured_media) gallery.goToMedia(variant.featured_media.id);
      });
    }
  }
  define('vcg-variant-picker', VcgVariantPicker);

  /* ---------- Mobile Kaufleiste ---------- */
  class VcgStickyBuy extends HTMLElement {
    connectedCallback() {
      var target = document.getElementById(this.getAttribute('data-target'));
      if (!target || !('IntersectionObserver' in window)) return;
      document.body.classList.add('has-sticky-buy');
      // Nur der unterste Footer-Streifen blendet die Leiste aus, damit sie
      // beim Weiterscrollen sichtbar bleibt und nichts Wichtiges verdeckt.
      var footer = $('.footer__bottom') || $('.site-footer');
      var targetVisible = true, footerVisible = false;
      // Am Computer erscheint die Leiste, sobald das erste Produktbild verlassen ist
      // (die Produktinfo läuft dort oft mit, der Kaufknopf wäre sonst nie „außer Sicht“).
      var firstImage = $('.pdp__media .gallery__slide') || $('.pdp__media');
      var desktop = window.matchMedia('(min-width: 990px)');
      var update = () => {
        var past = target.getBoundingClientRect().top < 0 && !targetVisible;
        if (desktop.matches && firstImage) past = past || firstImage.getBoundingClientRect().bottom < 0;
        var show = past && !footerVisible;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('sticky-buy-on', show);
      };
      window.addEventListener('scroll', debounce(update, 60), { passive: true });
      new IntersectionObserver(function (entries) { targetVisible = entries[0].isIntersecting; update(); }).observe(target);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
      var btn = this.querySelector('[data-sticky-submit]');
      if (btn) btn.addEventListener('click', function () {
        var submit = target.querySelector('[type="submit"]');
        if (submit) submit.click(); else target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
  define('vcg-sticky-buy', VcgStickyBuy);

  /* ---------- Empfehlungen nachladen ---------- */
  class VcgRecommendations extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || this.closest('[hidden]')) { this.load(); return; }
      var io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { io.disconnect(); this.load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
    load() {
      fetch(this.getAttribute('data-url'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then((text) => {
        var doc = parseHTML(text);
        var fresh = doc.querySelector('vcg-recommendations');
        if (fresh && fresh.innerHTML.trim()) {
          this.innerHTML = fresh.innerHTML;
          var hideWrap = this.closest('[data-hide-if-empty]');
          if (hideWrap) hideWrap.hidden = false;
          initReveal(this);
          initRails(this);
        }
      }).catch(function () {});
    }
  }
  define('vcg-recommendations', VcgRecommendations);

  /* ---------- Vorschausuche ---------- */
  class VcgPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.search(), 260));
    }
    search() {
      var q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictive_search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,query,collection,page&resources[limit]=8&resources[limit_scope]=each&section_id=predictive-search';
      fetch(url, { credentials: 'same-origin', signal: this.controller ? this.controller.signal : undefined })
        .then(function (r) { return r.text(); })
        .then((text) => {
          var doc = parseHTML(text);
          var fresh = doc.querySelector('[data-predictive-content]');
          this.results.innerHTML = fresh ? fresh.innerHTML : '';
          initReveal(this.results);
        }).catch(function () {});
    }
  }
  define('vcg-predictive-search', VcgPredictiveSearch);

  /* ---------- Filter & Sortierung ---------- */
  class VcgFacets extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sectionId = this.getAttribute('data-section');
      this.addEventListener('change', (e) => {
        var form = e.target.closest('form[data-facets-form]');
        if (!form) return;
        this.applyForm(form);
      });
      this.addEventListener('submit', (e) => {
        var form = e.target.closest('form[data-facets-form]');
        if (!form) return;
        e.preventDefault();
        this.applyForm(form);
        var drawer = e.target.closest('vcg-drawer');
        if (drawer) drawer.close();
      });
      this.addEventListener('click', (e) => {
        var link = e.target.closest('[data-facet-link]');
        if (!link) return;
        e.preventDefault();
        var fromPagination = !!link.closest('.pagination');
        this.load(link.getAttribute('href')).then(() => {
          if (fromPagination) {
            var top = this.getBoundingClientRect().top + window.scrollY - 20;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });
      this._pop = () => { if (this.isConnected) this.load(window.location.pathname + window.location.search, true); };
      window.addEventListener('popstate', this._pop);
    }
    applyForm(changedForm) {
      var params = new URLSearchParams();
      $$('form[data-facets-form]', this).forEach(function (form) {
        new FormData(form).forEach(function (value, key) {
          if (value === '' ) return;
          if (params.getAll(key).indexOf(value) === -1) params.append(key, value);
        });
      });
      // Doppelte Werte aus Drawer- und Toolbar-Formular vermeiden: das zuletzt geänderte gewinnt bei Einzelwerten
      if (changedForm) {
        new FormData(changedForm).forEach(function (value, key) {
          if (key === 'sort_by' || key.indexOf('.gte') > -1 || key.indexOf('.lte') > -1) params.set(key, value);
        });
      }
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      this.load(url);
    }
    load(url, fromHistory) {
      try { var u = new URL(url, window.location.origin); u.searchParams.delete('section_id'); url = u.pathname + u.search; } catch (e) {}
      var activeId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : '';
      var body = this.querySelector('.collection-body');
      if (body) body.classList.add('is-loading');
      return fetchSection(url, this.sectionId).then((doc) => {
        $$('[data-facets-part]', this).forEach(function (el) {
          var key = el.getAttribute('data-facets-part');
          var fresh = doc.querySelector('[data-facets-part="' + key + '"]');
          if (!fresh) return;
          // Offene Filtergruppen beibehalten
          var open = $$('details[open][data-group]', el).map(function (d) { return d.getAttribute('data-group'); });
          el.innerHTML = fresh.innerHTML;
          open.forEach(function (g) { var d = el.querySelector('details[data-group="' + g + '"]'); if (d) d.open = true; });
        });
        if (!fromHistory) window.history.pushState({}, '', url);
        document.dispatchEvent(new CustomEvent('vcg:facets-updated'));
        if (activeId) { var again = document.getElementById(activeId); if (again) again.focus({ preventScroll: true }); }
        initReveal(this);
      }).catch(function () { window.location.href = url; })
        .finally(() => { if (body) body.classList.remove('is-loading'); });
    }
  }
  define('vcg-facets', VcgFacets);

  /* ---------- Wischbare Reihen: Pfeile ---------- */
  function railFor(btn) {
    var nav = btn.closest('.rail-nav');
    var el = nav && nav.nextElementSibling;
    return el && el.classList.contains('rail') ? el : null;
  }
  function updateRailNav(rail) {
    var nav = rail.previousElementSibling;
    if (!nav || !nav.classList.contains('rail-nav')) return;
    var btns = nav.querySelectorAll('[data-rail-step]');
    btns[0].disabled = rail.scrollLeft <= 2;
    btns[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-step]');
    if (!btn) return;
    var rail = railFor(btn);
    if (rail) rail.scrollBy({ left: parseInt(btn.getAttribute('data-rail-step'), 10) * rail.clientWidth * 0.85, behavior: 'smooth' });
  });
  document.addEventListener('scroll', debounce(function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('rail')) updateRailNav(e.target);
  }, 80), true);
  function initRails(root) { $$('.rail', root).forEach(updateRailNav); }

  /* ---------- Rasterdichte in Kollektionen ---------- */
  function applyDensity(value) {
    $$('.product-grid--collection').forEach(function (g) { g.classList.toggle('is-large', value === 'large'); });
    $$('[data-density]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-density') === value ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-density]');
    if (!b) return;
    var v = b.getAttribute('data-density');
    try { localStorage.setItem('vcg-density', v); } catch (err) {}
    applyDensity(v);
  });
  function restoreDensity() { var v = 'small'; try { v = localStorage.getItem('vcg-density') || 'small'; } catch (err) {} applyDensity(v); }
  document.addEventListener('vcg:facets-updated', restoreDensity);
  if (document.querySelector('.product-grid--collection')) restoreDensity();

  /* ---------- Länder-/Sprachauswahl ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-localization-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- Start ---------- */
  /* ---------- Wunschliste ---------- */
  // Eigene Wunschliste: gespeichert im Browser, ohne App. Ist im Theme Swym
  // eingestellt, öffnet das Herz im Header stattdessen die Liste der App.
  var Wishlist = (function () {
    var KEY = 'vcg-wishlist';
    var strings = window.VCG_WISHLIST_STRINGS || {};
    function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} render(); }
    function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
    function add(item) { var list = read().filter(function (i) { return i.handle !== item.handle; }); item.added = Date.now(); list.unshift(item); write(list); }
    function remove(handle) { write(read().filter(function (i) { return i.handle !== handle; })); }
    function syncButtons() {
      $$('[data-wishlist-toggle]').forEach(function (btn) {
        var on = has(btn.getAttribute('data-handle'));
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-active', on);
        var label = on ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
        var span = btn.querySelector('[data-wishlist-label]');
        if (span) span.textContent = label; else btn.setAttribute('aria-label', label);
      });
      var n = read().length;
      $$('[data-wishlist-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; el.setAttribute('data-count', n); });
    }
    function renderDrawer() {
      var listEl = $('[data-wishlist-list]'); if (!listEl) return;
      var tpl = document.getElementById('WishlistItemTemplate');
      var list = read();
      listEl.innerHTML = '';
      list.forEach(function (item) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        $$('[data-wl-link]', li).forEach(function (a) { a.href = item.url; });
        var img = $('[data-wl-img]', li); if (item.image) img.src = item.image; else img.remove();
        $('[data-wl-brand]', li).textContent = item.brand || '';
        $('[data-wl-title]', li).textContent = item.title;
        $('[data-wl-ref]', li).textContent = item.ref ? 'Ref. ' + item.ref : '';
        $('[data-wl-price]', li).textContent = item.available === false ? (strings.soldOut || '') : (item.price || '');
        if (item.available === false) li.classList.add('is-sold');
        $('[data-wl-remove]', li).addEventListener('click', function () { remove(item.handle); });
        var addBtn = $('[data-wl-add]', li);
        if (addBtn) {
          if (item.available === false || !item.variant) addBtn.remove();
          else addBtn.addEventListener('click', function () { VCG.cart.add(item.variant, addBtn); });
        }
        listEl.appendChild(li);
      });
      var empty = $('[data-wishlist-empty]'); if (empty) empty.hidden = list.length > 0;
      var foot = $('[data-wishlist-foot]'); if (foot) foot.hidden = list.length === 0;
    }
    function render() { syncButtons(); renderDrawer(); }
    // Preise und Verfügbarkeit beim Öffnen aktualisieren
    function refresh() {
      var list = read(); if (!list.length) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(list.map(function (item) {
        return fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (results) {
        var cur = read();
        results.forEach(function (p, i) {
          if (!p) return;
          var it = cur.filter(function (x) { return x.handle === list[i].handle; })[0]; if (!it) return;
          it.available = !!p.available;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          if (v) it.variant = v.id;
          if (window.Intl && p.price != null) {
            try { it.price = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(p.price / 100); } catch (e) {}
          }
        });
        try { localStorage.setItem(KEY, JSON.stringify(cur)); } catch (e) {}
        render();
      });
    }
    function importShared() {
      var m = location.hash.match(/wishlist=([^&]+)/); if (!m) return;
      var handles = decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, 40);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(handles.map(function (h) { return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (ps) {
          ps.forEach(function (p) { if (p && !has(p.handle)) { var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0]; add({ handle: p.handle, title: p.title, url: p.url, image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '', price: '', brand: p.vendor, ref: '', available: p.available, variant: v ? v.id : null }); } });
          history.replaceState(null, '', location.pathname + location.search);
          refresh();
          var d = document.getElementById('WishlistDrawer'); if (d && d.open) d.open();
        });
    }
    function init() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-toggle]');
        if (btn) {
          e.preventDefault();
          var handle = btn.getAttribute('data-handle');
          if (has(handle)) { remove(handle); toast(strings.removed || ''); }
          else { var item = {}; try { item = JSON.parse(btn.getAttribute('data-item')); } catch (err) { item = { handle: handle, title: handle, url: '/products/' + handle }; } add(item); toast(strings.added || ''); }
          return;
        }
        var share = e.target.closest('[data-wishlist-share]');
        if (share) {
          var url = location.origin + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '#wishlist=' + read().map(function (i) { return i.handle; }).join(',');
          if (navigator.share) { navigator.share({ url: url }).catch(function () {}); }
          else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(function () { toast(strings.copied || ''); }); }
        }
      });
      document.addEventListener('drawer:open', function (e) { if (e.target && e.target.id === 'WishlistDrawer') refresh(); });
      window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
      render();
      importShared();
    }
    return { init: init, read: read, render: render, remove: remove, has: has };
  })();
  VCG.wishlist = Wishlist;

  /* ---------- Wunschliste: Vergleichsseite ---------- */
  class VcgCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      try { this.rows = JSON.parse(this.querySelector('[data-compare-rows]').textContent); } catch (e) { this.rows = []; }
      try { this.str = JSON.parse(this.querySelector('[data-compare-strings]').textContent); } catch (e) { this.str = {}; }
      this.table = this.querySelector('[data-compare-table]');
      this.querySelector('[data-compare-diff]').addEventListener('change', () => this.applyDiff());
      this.addEventListener('click', (e) => {
        var rm = e.target.closest('[data-compare-remove]');
        if (rm) { VCG.wishlist.remove(rm.getAttribute('data-compare-remove')); this.load(); return; }
        var add = e.target.closest('[data-compare-add]');
        if (add) VCG.cart.add(parseInt(add.getAttribute('data-compare-add'), 10), add);
      });
      this.load();
    }
    fetchItem(item) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'products/' + encodeURIComponent(item.handle);
      return fetch(url + '?section_id=wishlist-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) { var el = parseHTML(html).querySelector('[data-wishlist-data]'); if (!el) throw new Error(); return JSON.parse(el.textContent); })
        .catch(function () {
          return fetch(url + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
            if (!p) return null;
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
            return { handle: p.handle, title: p.title, url: p.url, image: item.image, price: item.price, available: p.available, variant: v && v.id, vendor: p.vendor, type: p.type, fields: { brand: item.brand, refernce_number: item.ref } };
          }).catch(function () { return null; });
        });
    }
    load() {
      var list = VCG.wishlist.read();
      var empty = this.querySelector('[data-compare-empty]');
      var bar = this.querySelector('[data-compare-toolbar]');
      empty.hidden = list.length > 0; bar.hidden = list.length === 0;
      this.querySelector('[data-compare-count]').textContent = (this.str.count || '').replace(/\{\{\s*count\s*\}\}/, list.length);
      if (!list.length) { this.table.innerHTML = ''; return; }
      this.classList.add('is-loading');
      Promise.all(list.map((i) => this.fetchItem(i))).then((items) => {
        this.items = items.filter(Boolean);
        this.render();
      }).finally(() => this.classList.remove('is-loading'));
    }
    render() {
      var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
      var items = this.items, str = this.str, html = '';
      html += '<thead><tr><th scope="col" class="compare__label"></th>' + items.map(function (it) {
        return '<th scope="col" class="compare__item"><a href="' + esc(it.url) + '" class="compare__media media">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" width="350" height="350">' : '') + '</a>' +
          '<a href="' + esc(it.url) + '" class="compare__name">' + esc(it.title) + '</a></th>';
      }).join('') + '</tr></thead><tbody>';
      html += '<tr data-row="price"><th scope="row" class="compare__label">' + esc(str.price) + '</th>' + items.map(function (it) {
        return '<td>' + (it.available ? '<span class="compare__price">' + esc(it.price) + '</span>' + (it.compare ? ' <s class="price__compare">' + esc(it.compare) + '</s>' : '') : '<span class="text-soft">' + esc(str.soldOut) + '</span>') + '</td>';
      }).join('') + '</tr>';
      this.rows.forEach(function (row) {
        var vals = items.map(function (it) { return row.key === 'type' ? it.type : ((it.fields || {})[row.key] || (row.key === 'brand' ? (it.fields || {}).marke || it.vendor : '')); });
        if (vals.every(function (v) { return !v; })) return;
        var same = vals.every(function (v) { return v === vals[0]; });
        html += '<tr' + (same ? ' data-same' : '') + '><th scope="row" class="compare__label">' + esc(row.label) + '</th>' + vals.map(function (v) { return '<td>' + (v ? esc(v) : '–') + '</td>'; }).join('') + '</tr>';
      });
      html += '<tr class="compare__actions"><th scope="row" class="compare__label"></th>' + items.map(function (it) {
        return '<td>' + (it.available && it.variant ? '<button type="button" class="button button--primary button--small button--full" data-compare-add="' + it.variant + '">' + esc(str.add) + '</button>' : '') +
          '<button type="button" class="link link--quiet text-soft compare__remove" data-compare-remove="' + esc(it.handle) + '">' + esc(str.remove) + '</button></td>';
      }).join('') + '</tr></tbody>';
      this.table.innerHTML = html;
      this.table.style.setProperty('--compare-cols', items.length);
      this.applyDiff();
    }
    applyDiff() {
      var on = this.querySelector('[data-compare-diff]').checked;
      $$('tr[data-same]', this.table).forEach(function (tr) { tr.hidden = on; });
    }
  }
  define('vcg-compare', VcgCompare);

  // Magazin: Beiträge mehrerer Blogs nach Datum sortieren, nach Thema filtern, schrittweise zeigen
  class VcgFeed extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.per = parseInt(this.getAttribute('data-per-page'), 10) || 9;
      this.shown = this.per; this.tag = '';
      var section = this.closest('section') || document;
      this.more = section.querySelector('[data-feed-more]');
      this.chips = $$('[data-feed-filter]', section);
      if (this.hasAttribute('data-sort')) {
        var items = $$('.mag-feed__item', this);
        items.sort(function (a, b) { return (parseInt(b.getAttribute('data-date'), 10) || 0) - (parseInt(a.getAttribute('data-date'), 10) || 0); });
        items.forEach(function (it) { this.appendChild(it); }, this);
      }
      var self = this;
      this.chips.forEach(function (c) {
        c.addEventListener('click', function () {
          self.tag = c.getAttribute('data-feed-filter') || '';
          self.chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          self.shown = self.per; self.update();
        });
      });
      if (this.more) this.more.addEventListener('click', function () { self.shown += self.per; self.update(); });
      this.update();
    }
    update() {
      var tag = this.tag, n = 0, total = 0;
      $$('.mag-feed__item', this).forEach(function (it) {
        var match = !tag || it.getAttribute('data-tags').indexOf('|' + tag + '|') > -1;
        if (match) total++;
        it.hidden = !match || ++n > this.shown;
      }, this);
      if (this.more) this.more.hidden = total <= this.shown;
    }
  }
  define('vcg-feed', VcgFeed);

  // Swym-Variante: Herz im Header öffnet die Liste der App
  function initSwymProxy() {
    var btn = $('[data-wishlist-proxy]');
    if (!btn) return;
    var selectors = ['.nm-wishlist-open-list-button', '#swym-welcome-button', '.swym-launcher', '[id^="swym-anchor"]'];
    var find = function () {
      for (var i = 0; i < selectors.length; i++) { var el = document.querySelector(selectors[i]); if (el && el !== btn) return el; }
      return null;
    };
    btn.addEventListener('click', function () {
      if (window._swat && window._swat.ui && typeof window._swat.ui.open === 'function') { window._swat.ui.open(); return; }
      var el = find(); if (el) el.click();
    });
  }

  // Produktinfo nur mitlaufen lassen, wenn sie ganz auf den Bildschirm passt –
  // sonst wäre der untere Teil unerreichbar und der Kaufbereich nie „außer Sicht“.
  function initPdpSticky() {
    var info = $('.pdp__info'); if (!info) return;
    var check = function () {
      var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset')) || 0;
      info.classList.toggle('is-tall', info.scrollHeight > window.innerHeight - off - 48);
    };
    check();
    window.addEventListener('resize', debounce(check, 150));
    if ('ResizeObserver' in window) new ResizeObserver(debounce(check, 100)).observe(info);
  }

  // WhatsApp-Knopf auf der Startseite erst unterhalb des Titelbilds
  function initHeroFlag() {
    var hero = $('#MainContent > .shopify-section:first-child .hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) { document.body.classList.toggle('hero-in-view', entries[0].isIntersecting); }, { threshold: 0.35 }).observe(hero);
  }

  // Try-on (Camweara): Die App setzt ihren Knopf (#tryonButton, mobil #MB_tryonButton)
  // irgendwo neben den Platzhalter. Wir holen ihn in den unsichtbaren Platzhalter
  // und zeigen stattdessen unseren eigenen Knopf im Theme-Stil, der den App-Knopf auslöst.
  // Die App fügt ihren Knopf nur bei freigeschalteten Artikeln ein.
  function initTryon() {
    var proxy = $('[data-tryon-proxy]'); var host = $('.tryon-host');
    if (!proxy || !host) return;
    var SEL = '#tryonButton, #MB_tryonButton';
    var current = function () { return host.querySelector(SEL) || host.querySelector('button, [onclick]'); };
    var adopt = function () {
      $$(SEL).forEach(function (b) { if (b.parentElement !== host) host.appendChild(b); });
      proxy.hidden = !current();
    };
    adopt();
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; adopt(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
    proxy.addEventListener('click', function () { var t = current(); if (t) t.click(); });
  }

  // Eigene Wunschliste aktiv: Knöpfe anderer Wunschlisten-Apps (z. B. Swym) im
  // Kaufbereich zuverlässig ausblenden – unabhängig davon, wie die App sie einfügt.
  function hideForeignWishlist() {
    if (!document.body.classList.contains('wl-theme')) return;
    var scope = $('.pdp__info'); if (!scope) return;
    var words = /wish\s?-?list|wunschliste|favorit|merkliste|liste de souhaits|lista de deseos|lista dei desideri|lista de desejos|ønskeliste|önskelista|verlanglijst|lista życzeń|ulubion/i;
    var sweep = function () {
      $$('button, a, [role="button"]', scope).forEach(function (el) {
        if (el.hasAttribute('data-wishlist-toggle') || el.closest('.pdp-actions, .enquiry-drawer, .tryon-host, [data-vcg-hidden]')) return;
        var cls = typeof el.className === 'string' ? el.className : '';
        if (!(words.test(el.textContent || '') || /swym|wishlist|wish-list/i.test(cls + ' ' + (el.id || '')))) return;
        var box = el;
        while (box.parentElement && box.parentElement !== scope && box.parentElement.children.length === 1 && !box.parentElement.matches('form, .pdp-actions, .buy-buttons, [class^="pdp__"]')) box = box.parentElement;
        box.style.setProperty('display', 'none', 'important'); box.setAttribute('data-vcg-hidden', 'wishlist');
      });
    };
    sweep();
    var mo = new MutationObserver(debounce(sweep, 60));
    mo.observe(scope, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  // Suche (Computer): Leiste deckt die ganze Kopfzeile ab, Eingabefeld sitzt in ihrer Mitte
  document.addEventListener('drawer:open', function (e) {
    if (!e.target || e.target.id !== 'SearchDrawer') return;
    var header = document.querySelector('.site-header');
    var bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    e.target.style.setProperty('--search-cover', bottom + 'px');
  });

  /* ---------- Lesetext: bestehende Inhalte automatisch aufwerten ---------- */
  // Arbeitet nur im Browser an der Darstellung – der Text im Shopify-Admin bleibt unverändert.
  /* ---------- Baukasten: Muster aus dem Shopify-Editor gestalten ----------
     Bild allein in einer Zeile        → großes Bild; kursive Zeile darunter = Bildunterschrift
     2–6 Bilder direkt hintereinander  → Bildstrecke nebeneinander
     Produktlink allein in einer Zeile → Produktkarte (mehrere hintereinander → Reihe)
     Fetter Link allein in einer Zeile → Knopf
     Zeile beginnt mit „Tipp:“, „Hinweis:“, „Wichtig:“ … → Hinweis-Kasten            */
  function meaningful(el) {
    return Array.prototype.filter.call(el.childNodes, function (n) {
      return n.nodeName !== 'BR' && !(n.nodeType === 3 && !n.textContent.replace(/ /g, ' ').trim());
    });
  }
  function soleChild(el) { var k = meaningful(el); return k.length === 1 && k[0].nodeType === 1 ? k[0] : null; }
  function imageOnly(el) {
    if (el.tagName === 'IMG') return [el];
    if (!/^(P|DIV|FIGURE|A|SPAN)$/.test(el.tagName) || el.closest('table')) return null;
    var imgs = $$('img', el);
    if (!imgs.length || el.textContent.replace(/[\s ]/g, '') !== '' || el.querySelector('iframe, video, table')) return null;
    return imgs;
  }
  function captionOf(el) {
    if (!el || el.tagName !== 'P') return null;
    var only = soleChild(el);
    return only && /^(EM|I)$/.test(only.nodeName) && el.textContent.trim().length < 240 ? el : null;
  }
  function productHandle(a) {
    if (!a || a.tagName !== 'A') return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#.]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function linkOnly(p) {
    if (p.tagName !== 'P') return null;
    var c = soleChild(p); if (!c) return null;
    if (c.tagName === 'A') return { a: c, bold: !!soleChild(c) && /^(STRONG|B)$/.test(soleChild(c).nodeName) };
    if (/^(STRONG|B)$/.test(c.tagName)) { var inner = soleChild(c); if (inner && inner.tagName === 'A') return { a: inner, bold: true }; }
    return null;
  }
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function buildProductCard(handle, link) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var strings = (window.VCG_DATA && VCG_DATA.strings) || {};
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var a = document.createElement('a'); a.className = 'prose-product'; a.href = link.getAttribute('href') || p.url;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=480' : '';
        a.innerHTML = '<span class="prose-product__media">' + (img ? '<img loading="lazy" alt="" src="' + img + '">' : '') + '</span>' +
          '<span class="prose-product__body"><span class="prose-product__brand"></span><span class="prose-product__title"></span>' +
          '<span class="prose-product__price"></span><span class="prose-product__cta"></span></span>';
        a.querySelector('.prose-product__brand').textContent = p.vendor || '';
        a.querySelector('.prose-product__title').textContent = p.title;
        a.querySelector('.prose-product__price').textContent = p.available ? money(p.price) : (strings.soldOut || '');
        a.querySelector('.prose-product__cta').textContent = strings.viewProduct || '';
        if (!p.available) a.classList.add('is-sold');
        return a;
      }).catch(function () { return null; });
  }
  var NOTE_RE = /^(Tipp|Hinweis|Wichtig|Gut zu wissen|Tip|Note|Important|Good to know|Conseil|Remarque|Consiglio|Nota|Importante|Consejo|Wskazówka|Uwaga|Ważne|Bemærk|Vigtigt|Godt at vide|Let op|Belangrijk|Goed om te weten)\s?:/i;
  function buildBlocks(prose) {
    var kids = Array.prototype.slice.call(prose.children);
    // Bilder und Bildstrecken
    for (var i = 0; i < kids.length; i++) {
      var imgs = imageOnly(kids[i]); if (!imgs) continue;
      var group = [kids[i]], all = imgs.slice(), j = i + 1;
      while (j < kids.length) {
        var more = imageOnly(kids[j]);
        if (more) { group.push(kids[j]); all = all.concat(more); j++; continue; }
        if (kids[j].tagName === 'P' && !meaningful(kids[j]).length) { group.push(kids[j]); j++; continue; }
        break;
      }
      var cap = captionOf(kids[j]);
      var fig = document.createElement('figure');
      var useful = all.length;
      group[0].before(fig);
      fig.className = useful > 1 ? 'prose__gallery prose__gallery--' + (useful === 2 || useful === 4 ? 2 : 3) : 'prose__figure';
      all.forEach(function (im) {
        var holder = im.parentElement && im.parentElement.tagName === 'A' ? im.parentElement : im;
        im.removeAttribute('style'); im.loading = im.loading || 'lazy';
        if (useful > 1) { var cell = document.createElement('div'); cell.className = 'prose__cell'; cell.appendChild(holder); fig.appendChild(cell); }
        else fig.appendChild(holder);
      });
      if (cap) { var fc = document.createElement('figcaption'); fc.innerHTML = cap.firstElementChild.innerHTML; fig.appendChild(fc); cap.remove(); j++; }
      group.forEach(function (g) { if (g.isConnected && !fig.contains(g)) g.remove(); });
      i = j - 1;
    }
    // Produktkarten, Knöpfe und Hinweise
    kids = Array.prototype.slice.call(prose.children);
    var row = null;
    kids.forEach(function (el) {
      var lo = linkOnly(el);
      var handle = lo && productHandle(lo.a);
      if (handle) {
        if (!row || row.nextElementSibling !== el) { row = document.createElement('div'); row.className = 'prose__products'; el.before(row); }
        var slot = document.createElement('div'); slot.className = 'prose__product-slot'; row.appendChild(slot); slot.appendChild(el);
        buildProductCard(handle, lo.a).then(function (card) { if (card) { slot.innerHTML = ''; slot.appendChild(card); } });
        return;
      }
      if (lo && lo.bold) {
        var b = document.createElement('p'); b.className = 'prose__cta';
        var a = lo.a; a.textContent = a.textContent.trim(); a.className = 'button'; b.appendChild(a); el.replaceWith(b);
        return;
      }
      if (el.tagName === 'P' && NOTE_RE.test(el.textContent.trim())) {
        var box = document.createElement('aside'); box.className = 'prose__note';
        el.before(box); box.appendChild(el);
        if (!el.querySelector('strong, b')) {
          var m = el.textContent.trim().match(NOTE_RE)[0];
          var first = el.firstChild;
          if (first && first.nodeType === 3 && first.textContent.trim().indexOf(m) === 0) {
            first.textContent = first.textContent.replace(m, '');
            var st = document.createElement('strong'); st.textContent = m + ' '; el.insertBefore(st, el.firstChild);
          }
        }
      }
    });
    $$('.prose__products', prose).forEach(function (r) { r.classList.add('prose__products--' + Math.min(r.children.length, 3)); });
  }

  function enhanceProse(root) {
    $$('[data-prose]', root).forEach(function (prose) {
      if (prose._enhanced) return; prose._enhanced = true;
      buildBlocks(prose);
      // 1. Fett gesetzte Absätze als Zwischenüberschrift (nur wenn der Text keine echten Überschriften hat)
      if (!prose.querySelector('h2, h3')) {
        $$('p', prose).forEach(function (p) {
          var kids = Array.prototype.filter.call(p.childNodes, function (n) { return !(n.nodeType === 3 && !n.textContent.trim()) && n.nodeName !== 'BR'; });
          if (kids.length !== 1 || !/^(STRONG|B)$/.test(kids[0].nodeName)) return;
          var text = p.textContent.trim();
          if (!text || text.length > 110) return;
          var h = document.createElement('h2'); h.className = 'prose__auto-heading'; h.textContent = text.replace(/:\s*$/, '');
          p.replaceWith(h);
        });
      }
      // 2. Zerteilte Tabellen zusammenführen
      $$('table', prose).forEach(function (t) {
        if (!t.isConnected) return;
        var next = t.nextElementSibling;
        while (next) {
          var skip = next.tagName === 'P' && !next.textContent.trim() && !next.querySelector('img');
          if (skip) { var n = next.nextElementSibling; next.remove(); next = n; continue; }
          var nextTable = next.tagName === 'TABLE' ? next : (next.children.length === 1 && next.firstElementChild.tagName === 'TABLE' && !next.textContent.replace(next.firstElementChild.textContent, '').trim() ? next.firstElementChild : null);
          if (!nextTable) break;
          var body = t.tBodies[0] || t;
          $$('tr', nextTable).forEach(function (tr) { body.appendChild(tr); });
          var dead = next; next = next.nextElementSibling; dead.remove();
        }
      });
      // 3. Tabellen scrollbar machen, erste Zeile als Kopf
      $$('table', prose).forEach(function (t) {
        if (!t.tHead && t.rows.length > 2) {
          var first = t.rows[0];
          if (first && first.querySelectorAll('td').length && (first.querySelector('strong, b') || first.textContent.length < 80)) {
            var head = t.createTHead(); head.appendChild(first);
            $$('td', first).forEach(function (td) { var th = document.createElement('th'); th.innerHTML = td.innerHTML; td.replaceWith(th); });
          }
        }
        if (!t.parentElement.classList.contains('prose__table')) { var w = document.createElement('div'); w.className = 'prose__table'; t.before(w); w.appendChild(t); }
      });
      // 4. Videos im 16:9-Rahmen
      $$('iframe[src*="youtube"], iframe[src*="vimeo"]', prose).forEach(function (f) {
        if (f.parentElement.classList.contains('prose__video')) return;
        var w = document.createElement('div'); w.className = 'prose__video'; f.before(w); w.appendChild(f);
      });
      // 5. Inhaltsverzeichnis
      var toc = document.querySelector('[data-toc]');
      var heads = $$('h2', prose);
      if (toc && heads.length >= 3) {
        var list = toc.querySelector('[data-toc-list]');
        heads.forEach(function (h, i) {
          if (!h.id) h.id = 'abschnitt-' + (i + 1) + '-' + h.textContent.toLowerCase().replace(/[^a-z0-9äöüß]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
          var li = document.createElement('li'); var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); list.appendChild(li);
        });
        toc.hidden = false;
        if ('IntersectionObserver' in window) {
          var links = $$('a', list);
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); }); });
          }, { rootMargin: '0px 0px -70% 0px' });
          heads.forEach(function (h) { io.observe(h); });
        }
      }
    });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy-link]');
    if (!c) return;
    var url = c.getAttribute('data-copy-link');
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast((window.VCG_WISHLIST_STRINGS || {}).copied || url); });
  });

  function init() {
    enhanceProse(document);
    initTryon();
    hideForeignWishlist();
    initPdpSticky();
    initHeroFlag();
    Wishlist.init();
    initSwymProxy();
    document.dispatchEvent(new CustomEvent('vcg:facets-updated'));
    initReveal(document);
    initRails(document);
    setStickyOffset();
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); setStickyOffset(); });
      document.addEventListener('shopify:block:select', function (e) {
        var slide = e.target.closest('.hero__slide');
        var show = e.target.closest('vcg-slideshow');
        if (slide && show) { show.stop(); show.go(show.slides.indexOf(slide)); }
        var panel = e.target.closest('[role="tabpanel"]');
        var tabs = e.target.closest('vcg-tabs');
        if (panel && tabs) tabs.select(tabs.panels.indexOf(panel));
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
